import React, {useState, useEffect, useCallback, useContext} from "react";
import "./report.css";
import {useDropzone} from "react-dropzone";
import Attachment from "../../Attachment";
import {CaseContext} from "../../Contexts/CaseContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import TextArea from "../../TextArea";

function Report(props) {
    const {
        currentCase,
        setReport,
        setActivePage,
        setAttachment,
        updateTimeline
    } = useContext(CaseContext);
    const [submit, setSubmit] = useState(false);
    const [attachments, setAttachments] = useState({});

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            const reader = new FileReader()

            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {
                setAttachments(attachments => ({...attachments, [`${file.name}`]: new Blob([reader.result])}));
            }
            reader.readAsArrayBuffer(file)
        })

    }, [])

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: "image/*, video/*, application/pdf",
        maxFiles: 25
    });

    // Handles user typing in text area
    const handleChange = (event) => {
        setReport(event.target.value);

        if (event.target.value !== "") {
            setSubmit(true);
        } else {
            setSubmit(false);
        }
    }
    
    const deleteAttachment = (key) => {
        const attachmentsCopy = {...attachments};
        delete attachmentsCopy[key];
        
        setAttachments(attachmentsCopy);
    }
    
    // Updates timeline as well as set active page as next page
    const nextPage = () => {
        setActivePage("Category");
        setAttachment(attachments);
        updateTimeline("Category", true);
    }

    // Updates timeline as well as set active page as previous page
    const prevPage = () => {
        setActivePage("Agreement");
        updateTimeline("Report", false);
    }

    return (
        <>
            {currentCase.activePage === "Report" &&
            <div className="d-flex flex-column">
                <div className="report-header required">
                    <h2 className="d-inline">Please enter your report in your own words</h2>
                    <h6 className="report-question mt-3 mb-3">Try to be specific about involved people, departments,
                        locations, dates, times, documents,
                        policies, etc.</h6>
                    <div className="report-header-text-area-container">
                        <TextArea value={currentCase.report} maxLength={2000} onChange={handleChange} />
                    </div>
                </div>
                <div className="mt-3">
                    <h2>Attach Supporting files</h2>
                    <p>To protect your identity, please ensure that all identifying information, such as metadata (e.g.
                        location), is removed from all files before uploading them.</p>
                    <div className="d-flex flex-md-row">
                        <div className="drag-and-drop">
                            <div {...getRootProps()}>
                                <input {...getInputProps()}/>
                                {
                                    isDragActive ?
                                        <div className="drag-and-drop-border active-border">
                                            <div
                                                className="drag-and-drop-text d-flex flex-column align-items-center justify-content-center">
                                                <p>
                                                    Drop files here...
                                                </p>
                                            </div>
                                        </div>
                                        :
                                        <div className="drag-and-drop-border">
                                            <div
                                                className="drag-and-drop-text d-flex flex-column align-items-center justify-content-center">
                                                <p>
                                                    Drag and drop files or click to browse
                                                </p>
                                                <FontAwesomeIcon size={"3x"} icon="cloud-upload-alt"/>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                        {Object.keys(attachments).length > 0 &&
                        <div className="drag-and-drop">
                            <div className="drag-and-drop-border no-pointer overflow-auto">
                                {Object.entries(attachments).map(([key, value], index) => {
                                    return <Attachment key={index} name={key} remove={() => deleteAttachment(key)}/>
                                })}
                            </div>
                        </div>
                        }
                    </div>
                    <div style={{"padding": "5px, 0, 0, 5px", "font-size": "14px"}}> <i>Supported Formats: .png, .jpg, .mp4 .pdf</i></div>
                </div>
                <div className="d-flex flex-md-row mt-5">
                    <button type="button" className="btn btn-outline-danger" onClick={() => prevPage()}>Back</button>
                    <button type="button" className="btn btn-outline-primary btn-ml-25" disabled={!submit}
                            onClick={() => nextPage()}>Continue
                    </button>
                </div>
            </div>
            }
        </>
    )
}


export default Report;